import React, { useEffect, useRef } from 'react'

import { useApp } from '@/core/contexts/app'
import { path } from '@/core/utils'

import ScrollDown from '../scroll-down/ScrollDown'
import Image from '@/components/base/image/Image'

import { ProductsProps } from './type'
import { classnames } from 'begonya/functions'
import { Container, Row } from '@/components/base/gridview'

const Products: React.FunctionComponent<ProductsProps> = ({
  title,
  subTitle,
  image,
  background,
  isStatic,
  product,
  description,
}) => {
  const app = useApp()
  const imageRef = useRef<HTMLInputElement>(null)
  const titleRef = useRef<HTMLInputElement>(null)

  const backgroundURL = path.asset(
    app.environment,
    background && background.src
  )

  return (
    <div
      className={classnames('products', isStatic && 'producs--static')}
      style={{ background: `url('${backgroundURL}')` }}
    >
      <div className="products-parallax">
        <h1 ref={titleRef} className="products-title">
          {title}
        </h1>
        {!isStatic && (
          <div ref={imageRef} className="products-layer">
            <Image {...image} alt="" />
            <Container size="extended">
              <Row>
                <div className="products-description">
                  <div className="products-description-head">
                    <div className="products-description-head-title">
                      <span>{subTitle}</span>
                      {product}
                    </div>
                  </div>
                  {description && (
                    <div
                      className="products-description-text"
                      dangerouslySetInnerHTML={{ __html: description }}
                    />
                  )}
                </div>
              </Row>
            </Container>
          </div>
        )}
      </div>
    </div>
  )
}

export default Products
